import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { SimpleLightbox } from "../Cards/VideoCardDeck/SimpleLightbox/SimpleLightbox";
import { YouTubeVideoEmbed } from "../Cards/VideoCardDeck/YouTubeVideoEmbed";
import { usePreloadImage } from "../../hooks";
import { getMediaType, getVideoType } from "./utils";
export const M44MediaViewer = ({ mediaFileUrl, posterUrl, isVideoLooping = true, alt, forcedMediaType, mediaWidth, mediaHeight, mediaMaxWidth, mediaMaxHeight, mediaClassname, addDivWrapper = true, shouldBrowserPreload = false, }) => {
    const [animation, setAnimation] = useState();
    useEffect(() => {
        if (mediaFileUrl?.includes("json")) {
            fetch(mediaFileUrl)
                .then((response) => response.json())
                .then((jsonData) => {
                setAnimation(jsonData);
            })
                .catch((error) => {
                console.error(error);
            });
        }
    }, [mediaFileUrl]);
    const isMediaTypeUndefined = (() => !mediaFileUrl && !forcedMediaType)();
    if (isMediaTypeUndefined) {
        return React.createElement(React.Fragment, null, "No media file provided");
    }
    const mediaType = (() => forcedMediaType || getMediaType(mediaFileUrl))();
    const wrapperClassName = (() => {
        if (!addDivWrapper) {
            return "";
        }
        if (!mediaClassname) {
            return "media-viewer";
        }
        return `media-viewer${mediaClassname ? ` ${mediaClassname}` : ""}`;
    })();
    if (mediaType === "image") {
        return React.createElement(ImageViewerFactory, { mediaFileUrl: mediaFileUrl, alt: alt, shouldBrowserPreload: shouldBrowserPreload, addDivWrapper: addDivWrapper });
    }
    if (mediaType === "video") {
        const videoType = getVideoType(mediaFileUrl);
        return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: wrapperClassName },
            React.createElement("video", { poster: posterUrl, autoPlay: true, muted: true, playsInline: true, loop: isVideoLooping, preload: shouldBrowserPreload ? "auto" : "metadata" },
                React.createElement(ConditionalVideoSource, { mediaFileUrl: mediaFileUrl, type: videoType }))));
    }
    if (mediaType === "youtube-iframe" && mediaFileUrl) {
        return (React.createElement(SimpleLightbox, { className: "trending-videos__lightbox-trigger" },
            React.createElement(YouTubeVideoEmbed, { videoUrl: mediaFileUrl, width: mediaWidth, height: mediaHeight, maxWidth: mediaMaxWidth, maxHeight: mediaMaxHeight })));
    }
    if (mediaType === "lottie-json") {
        return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: wrapperClassName },
            React.createElement(Lottie, { animationData: animation, loop: true, rendererSettings: {
                    filterSize: {
                        width: "200%",
                        height: "200%",
                        x: "-50%",
                        y: "-50%",
                    },
                } })));
    }
    return React.createElement(React.Fragment, null);
};
const ImageViewerFactory = ({ mediaFileUrl, alt = "", addDivWrapper = false, shouldBrowserPreload = false }) => {
    if (!mediaFileUrl) {
        return React.createElement(React.Fragment, null);
    }
    if (shouldBrowserPreload) {
        return (React.createElement(ImageViewerWithBrowserPreload, { mediaFileUrl: mediaFileUrl, alt: alt, addDivWrapper: addDivWrapper }));
    }
    return React.createElement(ImageViewer, { mediaFileUrl: mediaFileUrl, alt: alt, addDivWrapper: addDivWrapper });
};
const ImageViewer = ({ mediaFileUrl, alt = "", addDivWrapper = false }) => {
    if (!mediaFileUrl) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: "media-viewer" },
        React.createElement("img", { src: mediaFileUrl, alt: alt })));
};
const ImageViewerWithBrowserPreload = ({ mediaFileUrl, alt = "", addDivWrapper = false }) => {
    usePreloadImage(mediaFileUrl);
    if (!mediaFileUrl) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: "media-viewer" },
        React.createElement("img", { src: mediaFileUrl, alt: alt })));
};
const ConditionalVideoSource = ({ mediaFileUrl, type, }) => {
    if (!mediaFileUrl) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("source", { src: mediaFileUrl, type: type });
};
const WrapperEl = ({ addDivWrapper = false, className, children, }) => {
    if (!addDivWrapper) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement("div", { className: className }, children);
};
